import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  standalone: false,
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @Input() src = '';
  @Input() text = '';
  @Input() fullWidth = false;
  @Input() bgColor = 'secondary';
  @Input() textColor = 'primary';
  @Input() disabled = false;
  @Input() onButtonClick!: () => void;
  formGroup: FormGroup;

  constructor(private modalService: BsModalService) {}

  handleClick() {
    if (this.disabled) {
      return;
    }
    if (this.onButtonClick) {
      this.onButtonClick();
    }
  }
}
